import { useLocation, useNavigate } from 'react-router-dom'
import { confirmLeaveUnsavedChanges } from '@/lib/unsavedChanges'
import { getPedagogyActiveTab, pedagogyPaths, PEDAGOGY_SECTION_TABS } from '@/lib/pedagogyRoutes'
import { usePedagogyAccess } from '@/hooks/usePedagogyAccess'
import { useSuperAdmin } from '@/hooks/useSuperAdmin'
import { useAuthStore } from '@/store'

export function PedagogySectionNav() {
  const navigate = useNavigate()
  const location = useLocation()
  const userId = useAuthStore(state => state.user?.id)
  const { isPedagogySpecialist, isAdvanced, isPedagogyLead, isManagementCompany } = usePedagogyAccess()
  const { isSuperAdmin } = useSuperAdmin()
  const ownSpecialistReviewsPath = Boolean(
    isPedagogySpecialist
      && userId
      && location.pathname === pedagogyPaths.specialist(userId)
      && new URLSearchParams(location.search).get('tab') === 'reviews'
  )
  const activeTab = ownSpecialistReviewsPath
    ? 'reviews'
    : getPedagogyActiveTab(location.pathname)

  return (
    <nav aria-label="Раздел педагогов" className="border-b border-border">
      <div className="flex gap-5 overflow-x-auto scrollbar-hide">
        {PEDAGOGY_SECTION_TABS
          .filter(item => item.key !== 'reviewDistribution' || (isManagementCompany && (isAdvanced || isPedagogyLead || isSuperAdmin === true)))
          .filter(item => item.key !== 'roleRequests' || (
            isManagementCompany && (isAdvanced || isPedagogyLead)
          ))
          .map(item => {
          const active = activeTab === item.key

          return (
            <button
              key={item.key}
              type="button"
              onClick={() => {
                if (!confirmLeaveUnsavedChanges()) return
                const target = item.key === 'reviews' && isPedagogySpecialist && userId
                  ? `${pedagogyPaths.specialist(userId)}?tab=reviews`
                  : item.path
                navigate(target)
              }}
              aria-current={active ? 'page' : undefined}
              className={`relative shrink-0 pb-2.5 pt-1 text-sm font-medium transition-colors ${
                active ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {item.label}
              {active && <span className="absolute inset-x-0 bottom-[-1px] h-0.5 rounded-full bg-primary" />}
            </button>
          )
          })}
      </div>
    </nav>
  )
}
